<template>
  <div class="row">
    <div class="col-md-12">
      <Errorpage v-if="error" :msg="error" />
      <table v-if="!error" class="table table-hover table-responsive table-responsive-md">
        <thead>
          <th scope="col">Log Name</th>
          <th scope="col" class="text-right"># Certificates</th>
          <th scope="col" class="text-right">Uptime</th>
          <th scope="col" class="text-right">Resp. Time</th>
          <th scope="col" class="text-right">Last Update</th>
        </thead>
        <tbody>
          <template v-for="log in logs">
            <tr v-if="!log.Family" @click="view(log.Slug)">
              <td>{{ log.Name }}</td>
              <td class="text-right">{{ log.Count.toLocaleString() }}</td>
              <td class="text-right">{{ sprintPercent(log.Uptime) }}</td>
              <td class="text-right">{{ sprintDuration(log.ResponseTime) }}</td>
              <td class="text-right">{{ sprintDate(log.LastUpdate) }}</td>
            </tr>
            <template v-else>
              <tr><th colspan="5">{{ log.FamilyName }}</th></tr>
              <tr v-for="member in log.Members" @click="view(member.Slug)">
                <td class="family-member">&mdash; {{ member.Name }}</td>
                <td class="text-right">{{ member.Count.toLocaleString() }}</td>
                <td class="text-right">{{ sprintPercent(member.Uptime) }}</td>
                <td class="text-right">{{ sprintDuration(member.ResponseTime) }}</td>
                <td class="text-right">{{ sprintDate(member.LastUpdate) }}</td>
              </tr>
            </template>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import { default as utilMixin, loadData } from '@/components/mixins/util'
  import router from '@/router'

  import Errorpage from '@/components/widgets/Errorpage'

  export default {
    name: 'LogListpage',
    beforeRouteEnter: function(to, from, next) { loadData('/logs', next) },
    // beforeRouteUpdate omitted because this page has no parameters.

    data: function() {
      return {
        error: null,
        logs: null,
      }
    },
    methods: {
      setData(err, data) {
        if (err) {
          this.error = err.toString()
        } else {
          this.logs = data.Logs
        }
      },
      view: function(slug) { router.push({path: '/logs/'+slug}) },
    },
    components: { Errorpage },
    mixins: [utilMixin],
  }
</script>

<style scoped>
  table {
    margin-top: 1rem;
    width: 100%;

    white-space: nowrap;
  }
  table thead th {
    text-transform: uppercase;
    font-size: 0.8rem;
    font-weight: normal;
    color: gray;

    border-bottom: 1px solid #e5e5e5;
  }
  table tbody tr td {
    cursor: pointer;
  }
  td.family-member {
    padding-left: 3em;
  }
</style>



// WEBPACK FOOTER //
// src/components/LogListpage.vue